module.exports = __webpack_public_path__ + "static/media/cookieTimerHoles.aa06a017.png";